import {Component, OnInit} from '@angular/core';
import {Processo} from '../../comum/modelos/processo';
import {ProcessoService} from '../processo.service';
import {ComumService} from '../../comum/comum.service';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-cadastro-processo',
  templateUrl: './cadastro-processo.component.html',
  styleUrls: ['./cadastro-processo.component.css']
})
export class CadastroProcessoComponent implements OnInit {

  processo: Processo;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  public loading = false;
  public statusCode: number;

  constructor(private _processoService: ProcessoService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _authService: AuthService) {
    this.processo = new Processo();

  }

  ngOnInit() {
    this.obterProcessoPorId(this._activatedRoute.snapshot.params['id']);
  }

  obterProcessoPorId(id: number): void {
    this.loading = true;
    if (id !== undefined) {
      const self = this;
      this._processoService.obterProcessoPorIdHttp(id)
        .subscribe((processo: Processo) => {
          this.processo = processo;
          this.MODO = this.ATUALIZAR;
          this.loading = false;
        });
    } else {
      this.MODO = this.CADASTRAR;
      this.loading = false;
    }
  }

  onSubmit(): void {

    const self = this;

    if (this.MODO === this.CADASTRAR) {
      this._processoService.cadastrarProcessoHttp(this.processo)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-processos']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    } else {
      this._processoService.atualizarProcessoHttp(this.processo)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          self.router.navigate(['listar-processos']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/cadastro-processo/cadastro-processo.component.ts